"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.definedOrThrows = void 0;
const definedOrThrows = (value, what) => {
    if (value === undefined || value === null) {
        throw new Error(`${what} not found`);
    }
    return value;
};
exports.definedOrThrows = definedOrThrows;
//# sourceMappingURL=definedOrThrows.js.map